const twgl = require('twgl.js')
import Orientation from './Orientation'

import vertexShader from '../shaders/vert.glsl';
import fragmentShader from '../shaders/frag.glsl';

function glBackground() {
  var raf, canvas, gl, bufferInfo, shadersInfo
  // var dpi = window.devicePixelRatio || 1
  var dpi = 1
  var mouse = [window.innerWidth * 0.5 * dpi, window.innerHeight * 0.5 * dpi]
  var mouseState = 0
  var curMouseState = 0
  var curMouse = mouse.slice(0)
  var noiseDensity = 0.33
  var noiseBrightness = 0.43
  var isPerlin = true
  var touch = {
    sx: 0,
    sy: 0,
    dx: 0,
    dy: 0,
    isTouching: false,
    isTouch: false
  }

  function init() {
    setupGL()
    setupBuffer()
    setupShaders()
    setupEvents()
    // addControls()
    return {
      start,
      stop
    }
  }

  function setupGL() {
    canvas = document.createElement('canvas')
    canvas.classList.add('block', 'w-full', 'h-full')
    canvas.style.opacity = 0
    document.getElementById('bg-effect').appendChild(canvas)
    gl = twgl.getWebGLContext(canvas)
  }

  function setupBuffer() {
    var arrays = {
      position: [-1, -1, 0, 1, -1, 0, -1, 1, 0, -1, 1, 0, 1, -1, 0, 1, 1, 0],
    }
    bufferInfo = twgl.createBufferInfoFromArrays(gl, arrays)
  }

  function setupShaders() {
    shadersInfo = twgl.createProgramInfo(gl, [
      vertexShader,
      fragmentShader
    ])
  }

  function setupEvents() {
    // Mouse Move
    window.addEventListener('mousemove', function(e) {
      mouse[0] = e.clientX * dpi
      mouse[1] = (canvas.clientHeight - e.clientY) * dpi
    })
    // Mouse Down
    window.addEventListener('mousedown', function(e) {
      mouseState = 1
    }, false)
    // Mouse Up
    window.addEventListener('mouseup', function(e) {
      mouseState = 0
    }, false)
    // Touch
    window.addEventListener('touchstart', function(e) {
      touch.isTouch = true
      mouseState = 1
      if(e.touches.length) {
        touch.sx = e.touches[0].pageX
        touch.sy = e.touches[0].pageY
        mouse[0] = touch.sx * dpi
        mouse[1] = (canvas.clientHeight - touch.sy) * dpi
      }
    }, false)
    window.addEventListener('touchmove', function(e) {
      e.preventDefault()
      if(e.touches.length) {
        touch.sx = e.touches[0].pageX
        touch.sy = e.touches[0].pageY
        mouse[0] = touch.sx * dpi
        mouse[1] = (canvas.clientHeight - touch.sy) * dpi
      }
    }, false)
    window.addEventListener('touchend', function(e) {
      mouseState = 0
    }, false)
  }

  function ease(cur, target, easing=1.0) {
    return cur + (target - cur) * easing
  }

  function clamp(num, min, max) {
    return Math.min(Math.max(num, min), max)
  }

  function isMobile() {
    return window.innerWidth < 767
  }

  function getCellSize() {
    if(isMobile()) {
      return 59 * dpi
    }
    return 118 * dpi
  }

  function getRadius() {
    if(isMobile()) {
      return [.55 * window.innerWidth * dpi, .25 * window.innerWidth * dpi]
    }
    return [.5 * window.innerHeight * dpi, .2 * window.innerHeight * dpi]
  }

  function getRadiusIncrease() {
    if(isMobile()) {
      return 400
    }
    return 1000
  } 

  // Render
  function render(time) {
    mouse[0] += Orientation.x / -5.0
    mouse[0] = clamp(mouse[0], 0, window.innerWidth * dpi)
    mouse[1] += Orientation.y / -10.0
    mouse[1] = clamp(mouse[1], 0, window.innerHeight * dpi)
    // Resize canvas (if necessary)
    twgl.resizeCanvasToDisplaySize(gl.canvas, dpi)
    // Handle mouse position
    curMouse[0] = ease(curMouse[0], mouse[0])
    curMouse[1] = ease(curMouse[1], mouse[1])
    curMouseState = ease(curMouseState, mouseState, 0.04)
    // Clear viewport
    gl.viewport(0, 0, gl.canvas.width, gl.canvas.height)
    // Update Uniforms
    var cs = getCellSize()
    var uniforms = {
      cell_size: [cs, cs],
      mouse: curMouse,
      mouseDown: curMouseState,
      offset: [-15 * dpi, -15 * dpi],
      resolution: [gl.canvas.width, gl.canvas.height, dpi],
      stroke: [1.0, 1.0, 1.0],
      stroke_width: 1 * dpi,
      time: time * 0.001,
      radius: getRadius(),
      radiusIncrease: getRadiusIncrease(),
      pulseTime: time *  (isMobile() ? 0.0010 : 0.00075),
      noiseDensity: noiseDensity,
      noiseBrightness: noiseBrightness,
      isPerlin: isPerlin
    }
    // Draw
    gl.useProgram(shadersInfo.program)
    twgl.setBuffersAndAttributes(gl, shadersInfo, bufferInfo)
    twgl.setUniforms(shadersInfo, uniforms)
    twgl.drawBufferInfo(gl, bufferInfo)
  }

  function loop(time) {
    render(time)
    raf = window.requestAnimationFrame(loop)
  }

  function start() {
    raf = window.requestAnimationFrame(loop)
    setTimeout(() => {
      canvas.style.opacity = 1
    }, 100)
  }

  function stop() {
    window.cancelAnimationFrame(raf)
  }

  function addControls() {
    function createWrapper() {
      return document.createElement('div')
    }

    function createLabel() {
      var label = document.createElement('label')
      label.classList.add('cw')
      label.style.display = 'inline-block'
      label.style.minWidth = '2.5em'
      label.style.fontSize = '1.5em'
      label.style.textAlign = 'right'
      label.style.verticalAlign = 'middle'
      return label
    }

    function addSlider(appendTo, opts) {
      var wrapper = createWrapper()
      var label = createLabel()
      var slider = document.createElement('input')
      slider.setAttribute('type', 'range')
      slider.setAttribute('min', opts.min)
      slider.setAttribute('max', opts.max)
      slider.setAttribute('step', opts.step)
      slider.value = opts.value
      label.innerHTML = slider.value
      slider.addEventListener('input', function(e) {
        opts.onChange(this.value)
        label.innerHTML = this.value
      }, false)
      wrapper.append(slider)
      wrapper.append(label)
      appendTo.append(wrapper)
    }

    function addCheckbox(appendTo, opts) {
      var wrapper = createWrapper()
      var label = createLabel()
      label.innerHTML = opts.label
      var checkbox = document.createElement('input')
      checkbox.setAttribute('type', 'checkbox')
      checkbox.checked = opts.isChecked
      checkbox.addEventListener('change', function() {
        opts.onChange(this.checked)
      })
      wrapper.append(checkbox)
      wrapper.append(label)
      appendTo.append(wrapper)
    }

    var container = document.createElement('div')
    container.classList.add('psf', 't0', 'r0')
    container.style.padding = '2em'
    addSlider(container, {
      min: 0,
      max: 1,
      step: 0.01,
      value: noiseDensity,
      onChange: function(val) {
        noiseDensity = val
      }
    })
    addSlider(container, {
      min: 0,
      max: 1,
      step: 0.01,
      value: noiseBrightness,
      onChange: function(val) {
        noiseBrightness = val
      }
    })
    addCheckbox(container, {
      label: 'Perlin Noise',
      isChecked: isPerlin,
      onChange: function(val) {
        if(val) {
          isPerlin = true
        } else {
          isPerlin = false
        }
      }
    })
    document.body.append(container)
  }

  return init()
}

export default glBackground